import { appVersion } from './version'

export const environment = {
  production: true,
  environmentName: 'Melhorias',
  baseUrl: 'http://api.tgmob.melhoria.prolins.com.br/api/',
  googleMapsApiKey: 'AIzaSyA9sanaPLa3B7FntR9EUMdI3ZojdbWoSHg',
  version: appVersion,
}
